import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/cash-register-readings`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/cash-register-readings/${id}?include=organization,cashRegister,cashRegisterReadingItems,cashRegisterReadingExpenseItems,cashRegisterReadingPaymentItem`,
      options
    )
    .then((response) => {
      let cashRegisterReading = jsona.deserialize(response.data);
      delete cashRegisterReading.links;
      return cashRegisterReading;
    });
}

function add(event) {
  const payload = jsona.serialize({
    stuff: event,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/cash-register-readings?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(event) {
  const payload = jsona.serialize({
    stuff: event,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/cash-register-readings/${event.id}?include=organization`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/cash-register-readings/${id}`, options);
}

function validate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/cash-register-readings/${id}/validate`,
      options
    )
    .then((response) => {
      let cashRegisterReading = jsona.deserialize(response.data);
      delete cashRegisterReading.links;
      return cashRegisterReading;
    });
}

function cancel(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/cash-register-readings/${id}/cancel`,
      options
    )
    .then((response) => {
      let cashRegisterReading = jsona.deserialize(response.data);
      delete cashRegisterReading.links;
      return cashRegisterReading;
    });
}

function print(id) {
  const options = {
    headers: {},
    responseType: "blob",
  };

  return axios.get(`${url}/cash-register-readings/${id}/print`, options);
}

function recordSales(params = {}) {
  const options = {
    params,
  };

  return axios
    .get(`${url}/dashboard/cash-register-record-sales`, options)
    .then((response) => ({
      records: response.data.data,
      meta: response.data.meta,
    }));
}

/**
 * Ce que la caisse a enregistré pour une caisse et une journée (aucune écriture).
 * Réponse : { linked, snapshot, suggested_number_z } ; linked = false si la caisse
 * n'est pas reliée au logiciel de caisse.
 */
function istheraReadingPreview({ cashRegisterId, date, endDate }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
    params: { date, ...(endDate ? { end_date: endDate } : {}) },
  };

  return axios
    .get(`${url}/cash-registers/${cashRegisterId}/isthera-reading-preview`, options)
    .then((response) => response.data.data);
}

/**
 * Remplit une lecture en brouillon depuis la caisse. Réponse : { snapshot, applied }.
 */
function istheraPrefill(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/cash-register-readings/${id}/isthera-prefill`, {}, options)
    .then((response) => response.data.data);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  validate,
  cancel,
  print,
  recordSales,
  istheraReadingPreview,
  istheraPrefill,
};
